import React from 'react';
import { connect } from 'react-redux';
import { Button, Tooltip } from 'antd';
import { getTaxPayer, checkIfVolumeIsBeingCalculated } from "../../../helpers";


const VolumeButton = (props) => {
    const { onClick, label,schedule } = props
    
    const enable = schedule.taxId !== ''&& Array.isArray(schedule.taxId) && schedule.taxId.length > 0;
    return (
        <div>
             <Tooltip
                placement="bottom"
                title={!enable ? "Calcula tu estimado mensual para poder activar el programador de facturas." : ""}>
                <Button disabled={!enable} type="primary" onClick={onClick}> {label}</Button>
            </Tooltip> 
            
        </div>
    )
}

const enableButton = (taxpayer) => {
    if (!taxpayer) return true;
    return !checkIfVolumeIsBeingCalculated(taxpayer.createdDate, taxpayer.updatedDate);
}

const mapStateToProps = state => {
    return {
        taxpayerVolume: state.taxpayer.taxpayerVolume,
        schedule: state.schedule.scheduleRequest,
    }
}

export default connect(mapStateToProps, null)(VolumeButton);